module.exports = __webpack_public_path__ + "static/img/27.21df833.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/27.jpg
// module id = 9ZXL
// module chunks = 0